import { useEffect } from 'react';
import { GET_COUNTRIES } from '../constants/aryGraphqlSchemas';
import { useAryLazyQuery } from './useAryGraphql';

const useShowCountryName = () => {
  const [getCountries, { data: getCountriesQueryData }] = useAryLazyQuery({
    gqlConfig: GET_COUNTRIES,
    items: `
        countryCode
        countryFlagCode
        countryName
      `
  });

  useEffect(() => {
    getCountries({});
  }, []);

  const showCountryName = ({ countryCode }) => {
    const countryName = getCountriesQueryData?.find(
      (item) => item.countryCode === countryCode
    )?.countryName;
    return countryName || '-';
  };

  return showCountryName;
};

export default useShowCountryName;
